<form
  *ngIf="allowDeductibleOverrides$ | async"
  [formGroup]="deductibleOverridesForm"
  (ngSubmit)="onSubmit()"
  id="deductibleOverridesForm"
  data-cy="deductible-overrides-form"
>
  <div class="mb-3">
    <app-form-field
      *ngIf="(copay$ | async)?.allowOverridingPrimaryDeductible"
      [control]="asFormControl(deductibleOverridesForm.get('overridePrimaryDeductible'))"
      name="overridePrimaryDeductible"
      type="checkbox-binary"
      [noMargin]="true"
    >
      <span class="deductible-met-label small">Primary insurance deductible has been met</span>
    </app-form-field>
  </div>
  <div class="mb-3">
    <app-form-field
      *ngIf="(copay$ | async)?.allowOverridingSecondaryDeductible"
      [control]="asFormControl(deductibleOverridesForm.get('overrideSecondaryDeductible'))"
      name="overrideSecondaryDeductible"
      type="checkbox-binary"
      [noMargin]="true"
    >
      <span class="deductible-met-label small">Secondary insurance deductible has been met</span>
    </app-form-field>
  </div>
  <button
    pButton
    type="submit"
    [label]="
      (updateCopayDeductibleOverridesState$ | async)?.isLoading
        ? 'Updating Estimated Responsibility...'
        : 'Update Estimated Responsibility'
    "
    [disabled]="
      (hasUnsubmittedDeductibleOverrides$ | async) === false ||
      (updateCopayDeductibleOverridesState$ | async)?.isLoading
    "
    class="p-button-outlined p-button-sm w-full"
    data-cy="update-estimated-responsibility-button"
    appClickEvent
    eventName="order_wizard_update_epr_with_deductible_met"
  ></button>
</form>

<app-confirmation-modal
  [(visible)]="confirmDeductibleOverrides"
  title="Deductible Changes Found"
  [message]="
    'You have indicated that your primary and/or your secondary deductible has been met without updating your estimated patient responsibility. How would you like to proceed?'
  "
  submitLabel="Apply Current Changes"
  cancelLabel="Revert My Changes"
  (confirmAction)="onConfirmDeductibleOverrides()"
  (cancelAction)="onResetDeductibleOverrides()"
  data-cy="deductible-overrides-changes-modal"
>
</app-confirmation-modal>
